<main>
  <ng-container *ngIf="(orderStatus$ | async) !== OrderStatus.PENDING; else loader">
    <ng-container data-flow-step-kyt>
      <fin-check-in-know-your-trip
        [services$]="servicesWithEmptySeats$"
        [order$]="orderWithCheckInPax$"
        [bound$]="bound$"
        [hasPendingSeats]="hasUnpaidSeats$ | async"
        (clearPendingSeats)="clearPendingSeats()"
        (viewSeatmap)="goToSeatmapStep()"
        (initializePayment)="initializePayment($event)"
        (confirmStep)="confirmStep()"
      ></fin-check-in-know-your-trip>
    </ng-container>
  </ng-container>
</main>

<ng-template #loader>
  <div class="align-center fill">
    <fin-loader aria-live="polite" [type]="LoaderType.EMBEDDED" [waitingFor]="'MMB.checkIn.loadingOrder'"></fin-loader>
  </div>
</ng-template>

<ng-template #loadingModal let-modalLoaderState="modal">
  <div *ngIf="modalLoaderState !== 'off'">
    <link rel="dns-prefetch" [href]="checkoutUrl | finSafe: 'resource'" />

    <fcom-modal
      [fitToContent]="true"
      [forceRemainOpen]="true"
      [open]="true"
      [title]="
        (modalLoaderState === 'payment'
          ? 'MMB.checkIn.review.titles.settingUpPayment'
          : 'MMB.checkIn.review.titles.updatingServices'
        ) | finLocalization
      "
      [buttons]="null"
    >
      <fin-loader
        aria-live="polite"
        [hideTitle]="true"
        [type]="LoaderType.EMBEDDED"
        [waitingFor]="
          modalLoaderState === 'payment' ? 'MMB.checkIn.review.waitingForPayment' : 'MMB.checkIn.review.clearingSeats'
        "
      ></fin-loader>
    </fcom-modal>
  </div>
</ng-template>

<ng-container *ngTemplateOutlet="loadingModal; context: { modal: (loadingModal$ | async) }"></ng-container>
